<template>
    <div class="__title" @click="$emit('toggle-collapse')">
        <div class="__title-sub">
            <div class="__chat-header">
                <div class="profile-brand">
                    <img v-if="profile.profile_picture" class="profile-image"
                        :src="$fullUrl('images/profiles/' + profile.profile_picture)" />
                    <img v-else class="profile-image" src="@/assets/avatar.png" />
                    <div v-show="profile.is_online" class="dot"></div>
                </div>

                <div class="user-info">
                    <span class="names">{{ profile.first_name | validate }}
                        {{ profile.last_name | validate }}</span>
                    <div v-show="profile.is_online" class="online">
                        <span>online</span>
                    </div>
                </div>
            </div>
            <img class="closer" src="@/assets/icons/close.svg" @click.stop="$emit('remove')" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChatHeader',
    props: {
        profile: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.__title {
    height: 67px;
    width: 100%;
    background: transparent linear-gradient(99deg, #1ba5a4 0%, #1ba5a4 21%, #1885ad 100%) 0% 0% no-repeat padding-box;
    border-radius: 10px 10px 0px 0px;
    display: flex;
    align-items: center;


    .__title-sub {
        cursor: pointer;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        color: #fff;
        font-weight: bold;
        border: none;
        align-items: center;
        padding: 0px 17px;

        .__chat-header {
            display: flex;
            align-items: center;

            .profile-brand {
                position: relative;
                display: flex;
                align-items: center;

                .profile-image {
                    width: 31px;
                    height: 31px;
                    border-radius: 50%;
                    margin-right: 10px;
                }

                .dot {
                    width: 5px;
                    height: 6px;
                    background: #42b72a;
                    border-radius: 50%;
                    border: 2px solid #fff;
                    position: absolute;
                    bottom: 7px;
                    right: 10px;
                }
            }

            .user-info {
                display: flex;
                flex-direction: column;
                align-items: flex-start;

                .names {
                    color: #fff;
                    height: 15px;
                }

                .online {
                    height: 15px;

                    span {
                        color: #e7e7e7;
                        font-size: 12px;
                        margin-top: 0;
                        margin-bottom: 0;
                        padding: 0;
                    }
                }
            }
        }

        .closer {
            width: 13px;
        }
    }
}
</style>